import type {ReactNode} from 'react'
import type {ProductDocument} from '@/types/sanity'
import {ProductCard} from '@/components/products/ProductCard'
import {isProductDiscontinued} from '@/components/products/productDisplay'

type ProductsGridProps = {
  products: ProductDocument[]
  locale?: string
  resolveHref: (product: ProductDocument) => string
  renderSecondaryCta?: (product: ProductDocument) => ReactNode
  ctaLabel?: string
  showHighlights?: boolean
  marketKey?: string
  hideProductPrices?: boolean
  priorityCardCount?: number
}

const DEFAULT_PRIORITY_CARDS = 3

export function ProductsGrid({
  products,
  locale,
  resolveHref,
  renderSecondaryCta,
  ctaLabel,
  showHighlights,
  marketKey,
  hideProductPrices = false,
  priorityCardCount = DEFAULT_PRIORITY_CARDS,
}: ProductsGridProps) {
  const activeProducts = products.filter((product) => !isProductDiscontinued(product))
  return (
    <div className="grid grid-cols-1 gap-card-gap sm:grid-cols-2 xl:grid-cols-3">
      {activeProducts.map((product, index) => (
        <ProductCard
          key={
            product._id ||
            ('objectID' in product ? String(product.objectID || '') : '') ||
            product.productNumber ||
            resolveHref(product)
          }
          product={product}
          href={resolveHref(product)}
          locale={locale}
          ctaLabel={ctaLabel}
          secondaryCta={renderSecondaryCta?.(product)}
          showHighlights={showHighlights}
          marketKey={marketKey}
          hideProductPrices={hideProductPrices}
          priority={index < priorityCardCount}
        />
      ))}
    </div>
  )
}
